import React from 'react';
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import PrivacyDropdown from "../PrivacyDropdown/PrivacyDropdown";
import ContactsTable from "../../ContactsTable/ContactsTable";
import './styles.scss';
import { Translate } from "react-localize-redux";

const ContactsFormPanel = () => (
  <CollapseContainer title={<Translate id="Contacts" />} startCollapsed={true}>
    <div className="col-2 col-left-padding">
      <Translate id="PrivacyText" />
    </div>
    <div className="col-1 col-left-padding">
      <PrivacyDropdown
        selectLabel="Privacy"
        selectName={'privacy'}
      />
    </div>
    <br/>
    <div className="row">
      <div className="col-12">
        <ContactsTable/>
      </div>
    </div>
  </CollapseContainer>
);

export default ContactsFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/ContactsFormPanel/ContactsFormPanel.jsx